export default "__VITE_ASSET__aea9ae6e__"